import React, { useState } from "react";
import { FacebookCircleFilledIcon } from "../Icons/SocialMedia/FacebookCircleFilledIcon";
import { XCircleFilledIcon } from "../Icons/SocialMedia/XCircleFilledIcon";
import { InstagramCircleFilledIcon } from "../Icons/SocialMedia/InstagramCircleFilledIcon";
import { LinkedInCircleFilledIcon } from "../Icons/SocialMedia/LinkedInCircleFilledIcon";
import { PrivacyPolicyModal } from "Components/PrivacyPolicyModal/PrivacyPolicyModal";
import { TermsAndConditionsModal } from "Components/TermsAndConditionsModal/TermsAndConditionsModal";
import logoIcon from "../../Recursos/genesis_logo_icon_vibrant.webp";
import whatsappImage from "../../Recursos/whatsapp.webp";
import llamaGratisImage from "../../Recursos/llama_gratis.webp";
import { useNavigate } from "react-router-dom";
import { RUTAS } from "rutas";
import { paramService } from "Services/param_service";
import { useQuery } from "Hooks/useQuery";
import "./Footer.scss";

/**
 * Componente Footer para la aplicación
 *
 * @param {string} [className=''] - Clases CSS adicionales para aplicar al footer
 * @param {Object} props - Props adicionales para pasar al elemento footer
 */
export const Footer = ({ className = "", ...props }) => {
  const [openPrivacyPolicy, setOpenPrivacyPolicy] = useState(false);
  const [openTermsAndConditions, setOpenTermsAndConditions] = useState(false);
  const navigate = useNavigate();

  const { data: contact } = useQuery(paramService.param, {
    grupo: "contacto",
  });

  const { data: footer } = useQuery(paramService.param, {
    componente: "footer",
  });

  const { data: images } = useQuery(paramService.param, {
    grupo: "imagenes",
    files: true,
  });

  const { data: legal } = useQuery(paramService.param, {
    grupo: "legal",
  });

  const getParamValue = (data, codigo) => {
    if (!data || !Array.isArray(data)) return null;
    const param = data.find((p) => p.codigoParametro === codigo);
    return param?.parametro || null;
  };

  const getUrlValue = (data, codigo) => {
    if (!data || !Array.isArray(data)) return null;
    const param = data.find((p) => p.codigoParametro === codigo);
    return param?.url || null;
  };

  const whatsappUrl = getParamValue(contact?.data, "whatsApp") || "#";
  const llamaGratisUrl = getParamValue(contact?.data, "llamaGratis") || "#";
  const facebookUrl = getParamValue(footer?.data, "facebook") || "#";
  const twitterUrl = getParamValue(footer?.data, "twitter") || "#";
  const instagramUrl = getParamValue(footer?.data, "instagram") || "#";
  const linkedInUrl = getParamValue(footer?.data, "linkedIn") || "#";
  const logoFooterImg = getUrlValue(images?.data, "logo_fotter") || "#";
  const numeroWhatsappImg = getUrlValue(images?.data, "numero_whatsapp") || "#";
  const numeroGratuitoImg = getUrlValue(images?.data, "numero_gratuito") || "#";
  const terminos = getParamValue(legal?.data, "terminos") || "";
  const politicas = getParamValue(legal?.data, "politicas") || "";

  const currentyear = new Date().getFullYear();

  const handleOpenPrivacyPolicy = () => {
    setOpenPrivacyPolicy(true);
  };

  const handleClosePrivacyPolicy = () => {
    setOpenPrivacyPolicy(false);
  };

  const handleOpenTermsAndConditions = () => {
    setOpenTermsAndConditions(true);
  };

  const handleCloseTermsAndConditions = () => {
    setOpenTermsAndConditions(false);
  };

  const handleLogoClick = () => {
    navigate(RUTAS.PRINCIPAL);
  };

  return (
    <footer className={`custom-footer ${className}`} {...props}>
      <div className="custom-footer__cintillo" />

      <div className="custom-footer__content">
        <div className="custom-footer__logo" onClick={handleLogoClick}>
          <img
            src={logoFooterImg}
            alt="Genesis Logo"
            width={70}
            height={70}
            onError={(e) => {
              e.target.src = logoIcon;
            }}
          />
        </div>

        <div className="custom-footer__contact">
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="WhatsApp"
          >
            <img
              src={numeroWhatsappImg}
              width={126}
              alt="WhatsApp"
              onError={(e) => {
                e.target.src = whatsappImage;
              }}
            />
          </a>
          <a
            href={llamaGratisUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Llama Gratis"
          >
            <img
              src={numeroGratuitoImg}
              width={161}
              alt="Llama Gratis"
              onError={(e) => {
                e.target.src = llamaGratisImage;
              }}
            />
          </a>
        </div>

        <p className="paragraph-m-medium mb-0">
          Síguenos en nuestras redes sociales:
        </p>
        <div className="custom-footer__social-icons">
          <a
            href={facebookUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <FacebookCircleFilledIcon />
          </a>
          <a
            href={twitterUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Twitter"
          >
            <XCircleFilledIcon />
          </a>
          <a
            href={instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <InstagramCircleFilledIcon />
          </a>
          <a
            href={linkedInUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
          >
            <LinkedInCircleFilledIcon />
          </a>
        </div>
      </div>

      <div className="custom-footer__bottom">
        <div className="custom-footer__links">
          <p
            onClick={handleOpenTermsAndConditions}
            className="custom-footer__link paragraph-s-regular text-blanco mb-0"
          >
            Términos y condiciones
          </p>
          <span className="paragraph-s-regular text-blanco">|</span>
          <p
            onClick={handleOpenPrivacyPolicy}
            className="custom-footer__link paragraph-s-regular text-blanco mb-0"
          >
            Políticas de privacidad
          </p>
        </div>
        <div className="custom-footer__copyright">
          <p className="paragraph-s-regular text-blanco mb-0">
            Derechos reservados© {currentyear} FGE
          </p>
          <span className="paragraph-s-regular text-blanco custom-footer__copyright__separator">
            |
          </span>
          <p className="paragraph-s-regular text-blanco mb-0">
            Powered by Funtec
          </p>
        </div>
      </div>

      <TermsAndConditionsModal
        openTermsAndConditions={openTermsAndConditions}
        handleCloseTermsAndConditions={handleCloseTermsAndConditions}
        terminos={terminos}
      />

      <PrivacyPolicyModal
        openPrivacyPolicy={openPrivacyPolicy}
        handleClosePrivacyPolicy={handleClosePrivacyPolicy}
        politicas={politicas}
      />
    </footer>
  );
};
